import * as React from 'react';

import Image from '@/components/elements/Image';
import TimeInfo from '@/components/layouts/News/TimeInfo';
import { Campaign } from '@/lib/microcms/model';
import { Content, NewsType } from '@/pages/News/types';

import {
  EntryStatus,
  ItemTitle,
  List,
  ListItem,
  StyledLink,
  Thumbnail,
  TitleWrapper,
} from './style';

interface NewsIndexListProps {
  type: NewsType;
  contentsList: Content[];
  enteringCampaignIds?: string[];
  isTop?: boolean;
  visibleEntryStatus?: boolean;
  visiblePublishedAt?: boolean;
}

const NewsIndexList: React.FC<NewsIndexListProps> = ({
  type,
  contentsList,
  enteringCampaignIds = [],
  isTop = false,
  visibleEntryStatus = false,
  visiblePublishedAt = true,
}) => {
  const isEntered = (cpid?: string) => {
    if (enteringCampaignIds && cpid) {
      return (
        enteringCampaignIds.filter(item => item.indexOf(cpid) == 0).length !== 0
      );
    }
    return false;
  };

  return (
    <List hasBorder={isTop}>
      {contentsList.map(item => (
        <ListItem key={item.id}>
          <StyledLink to={`/${type}/${item.id}`}>
            {item.featuredImage && (
              <div>
                <Thumbnail isEntered={isEntered((item as Campaign).id)}>
                  <Image
                    srcSet={`${item.featuredImage.url}?w=192&dpr=1 1x, ${item.featuredImage.url}?w=192&dpr=2 2x`}
                    mediaSet={[
                      {
                        srcSet: `${item.featuredImage.url}?w=192&dpr=1&fm=webp 1x, ${item.featuredImage.url}?w=192&dpr=2&fm=webp 2x`,
                        type: 'image/webp',
                      },
                    ]}
                    alt={item.title}
                    width={['144px', '144px', '192px', '192px']}
                    height={['45px', '45px', '60px', '60px']}
                  />
                </Thumbnail>
                {visibleEntryStatus && type === NewsType.Campaign && (
                  <EntryStatus isEntered={isEntered((item as Campaign).id)}>
                    <span>
                      {isEntered((item as Campaign).id)
                        ? 'エントリー済'
                        : 'エントリー受付中'}
                    </span>
                  </EntryStatus>
                )}
              </div>
            )}
            <TitleWrapper isNews={type === NewsType.News && !isTop}>
              {visiblePublishedAt && <TimeInfo content={item} />}
              <ItemTitle>{item.title}</ItemTitle>
            </TitleWrapper>
          </StyledLink>
        </ListItem>
      ))}
    </List>
  );
};

export default NewsIndexList;
